import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from "react-image-gallery";

const ImagesGallery = () => {
  const [images, setImages] = React.useState(null);

  React.useEffect(() => {
    let shouldCancel = false;

    const call = async () => {
      const response = await axios.get(
        "https://unmarred-pewter-fuschia.glitch.me/oSh1uUQ6oWC4zspN7"
      );
      if (!shouldCancel && response.data && response.data.length > 0) {
        console.log("Pics" + response.data.length);
        setImages(
          response.data.map((url) => ({
            original: `${url}=w1024`,
            thumbnail: `${url}=w100`
          }))
        );
      }
    };
    call();
    return () => (shouldCancel = true);
  }, []);

  return images ? (
    <ImageGallery
      items={images}
      autoPlay={true}
      showNav={false}
      showFullscreenButton={false}
      showThumbnails={false}
      slideInterval={6000}
    />
  ) : null;
};

const rootElement = document.getElementById("root");
ReactDOM.render(<ImagesGallery />, rootElement);
